import React from 'react'
import './index.scss';

import {User} from '../../store/ducks/user/types';


import SocialLogin from 'react-social-login'

interface OwnProps {
  triggerLogin: any;
  className: any;
}

interface DispatchProps {
  doLogin(user: User): void;
}

type Props = DispatchProps & OwnProps;
 
class SocialButton extends React.Component<Props> {

  render() {
    return (
      <button onClick={this.props.triggerLogin} {...this.props} className={`social-button ${this.props.className || ""}`}>
        { this.props.children }
      </button>
    );
  }
}
 
export default SocialLogin(SocialButton);